export enum LoadingTypes {
  LOADING_START = 'LOADING_START',
  INITIATE = 'INITIATE',
  LOADING_FINISHED = 'LOADING_FINISHED',
}
